import { OrderedMap } from 'immutable';
import { getFromJS } from '../../utils/storeUtility';

import {
	Action,
	CLEAR_FILTERS,
	FILTERS_CHANGED,
	OBJECTS_FAILED,
	OBJECTS_REQUESTED,
	OBJECTS_SUCCEEDED,
	OFFSET_CHANGED,
	SEARCH_STR_CHANGED,
	UPDATE_CANCEL_TOKEN,
	SORT_CHANGED,
	REMOVE_OBJECTS
} from './actions';

import {
	initialState,
	instanceStoreRecord,
	ObjectsStoreRecordType,
} from './store';

export const reducer = (
	state: ObjectsStoreRecordType = initialState,
	action: Action
): ObjectsStoreRecordType => {
	switch (action.type) {
		case OBJECTS_REQUESTED: {
			let inState = state;
			if (!inState.getIn(['instances', action.instanceId])) {
				inState = inState.setIn(
					['instances', action.instanceId],
					instanceStoreRecord(action.defaultInstance || {})
				);
			} else if (action.defaultInstance) {
				inState = inState.mergeIn(
					['instances', action.instanceId],
					action.defaultInstance
				);
			}
			return inState
				.setIn(['instances', action.instanceId, 'inProgress'], true)
				.setIn(
					['instances', action.instanceId, 'filters'],
					action.filters
				)
				.setIn(['instances', action.instanceId, 'offset'], 0)
				.setIn(
					['instances', action.instanceId, 'objects'],
					OrderedMap<string, any>()
				)
				.setIn(['instances', action.instanceId, 'error'], false);
		}
		case OBJECTS_SUCCEEDED: {
			const objects = getFromJS(action.instanceId)(action.objects);
			const inState = state
				.setIn(['instances', action.instanceId, 'inProgress'], false)
				.setIn(['instances', action.instanceId, 'paginationInProgress'], false)
				.setIn(['instances', action.instanceId, 'count'], action.count)
				.setIn(['instances', action.instanceId, 'globalCount'], action.globalCount)
				.setIn(['instances', action.instanceId, 'error'], false)
				.setIn(['instances', action.instanceId, 'cancelToken'], null);
			if (action.merge) {
				return inState.mergeIn(
					['instances', action.instanceId, 'objects'],
					OrderedMap(),
					objects
				);
			}
			return inState.setIn(
				['instances', action.instanceId, 'objects'],
				objects
			);
		}
		case OBJECTS_FAILED:
			return state
				.setIn(['instances', action.instanceId, 'inProgress'], false)
				.setIn(['instances', action.instanceId, 'paginationInProgress'], false)
				.setIn(
					['instances', action.instanceId, 'objects'],
					OrderedMap()
				)
				.setIn(['instances', action.instanceId, 'error'], true);
		case OFFSET_CHANGED:
			return state
				.setIn(['instances', action.instanceId, 'paginationInProgress'], true)
				.setIn(
					['instances', action.instanceId, 'offset'],
					action.offset
				);
		case SEARCH_STR_CHANGED:
			return state
				.setIn(['instances', action.instanceId, 'inProgress'], true)
				.setIn(
					['instances', action.instanceId, 'searchStr'],
					action.searchStr
				)
				.setIn(['instances', action.instanceId, 'offset'], 0)
				.setIn(
					['instances', action.instanceId, 'objects'],
					OrderedMap<string, any>()
				);
		case FILTERS_CHANGED:
			return state
				.setIn(['instances', action.instanceId, 'inProgress'], true)
				.setIn(
					['instances', action.instanceId, 'filters'],
					action.filters
				)
				.setIn(['instances', action.instanceId, 'offset'], 0)
				.setIn(
					['instances', action.instanceId, 'objects'],
					OrderedMap<string, any>()
				);
		case SORT_CHANGED:
			return state
				.setIn(['instances', action.instanceId, 'inProgress'], true)
				.setIn(
					['instances', action.instanceId, 'sort'],
					action.sort
				)
				.setIn(['instances', action.instanceId, 'offset'], 0)
				.setIn(
					['instances', action.instanceId, 'objects'],
					OrderedMap<string, any>()
				);
		case UPDATE_CANCEL_TOKEN:
			return state
				.setIn(['instances', action.instanceId, 'cancelToken'], action.cancelToken);
		case CLEAR_FILTERS:
			return state
				.setIn(['instances', action.instanceId, 'inProgress'], true)
				.setIn(
					['instances', action.instanceId, 'filters'],
					action.filters
				)
				.setIn(
					['instances', action.instanceId, 'searchStr'],
					action.searchStr
				)
				.setIn(['instances', action.instanceId, 'offset'], 0)
				.setIn(
					['instances', action.instanceId, 'objects'],
					OrderedMap<string, any>()
				);
		case REMOVE_OBJECTS:
			return state.deleteIn(['instances', action.instanceId]);
		default:
			break;
	}
	return state;
};
